import Button from '@shared/components/Button/Button';
import cx from 'classnames';

import { ReactComponent as Building } from 'assets/icons/Building.svg';
import { ReactComponent as User } from 'assets/icons/UserNew.svg';

interface WorkspaceTitleButtonProps {
  name: string;
  depth?: number;
  className?: string;
  onClick?: () => void;
  isPersonal?: boolean;
  avatarUrl?: string;
  compact?: boolean;
}

const WorkspaceTitleButton = ({
  name,
  depth = 0,
  className,
  onClick,
  isPersonal = false,
  avatarUrl,
  compact = false,
}: WorkspaceTitleButtonProps) => {
  const padding = compact ? '!py-0' : !depth ? '!py-2' : '!py-1.5';
  const Icon = isPersonal ? User : Building;

  const content = (
    <>
      {avatarUrl ? (
        <img className={cx('rounded-md object-cover', compact ? 'h-5 w-5' : 'h-6 w-6')} src={avatarUrl} alt={name} />
      ) : (
        <div className={cx('bg-primary-50 rounded-lg z-10', compact ? 'p-[3px]' : 'p-[5px]')}>
          <Icon className={cx('stroke-white', compact ? 'h-3 w-3' : 'h-3.5 w-3.5')} />
        </div>
      )}
      <div className="ml-2 min-w-0 truncate text-sm group-hover:text-primary-50">{name}</div>
    </>
  );

  const sharedClassName = cx(
    '!justify-start !font-light group flex min-w-0 items-center',
    { '!px-2': !compact },
    padding,
    className
  );

  if (!onClick) {
    return <div className={sharedClassName}>{content}</div>;
  }

  return (
    <Button variant="lightTextButton" className={sharedClassName} onClick={onClick}>
      {content}
    </Button>
  );
};

export default WorkspaceTitleButton;
